/// Menu
import MetisMenu from "metismenujs";
import React, { Component } from "react";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
/// Link
import { Link } from "react-router-dom";
//css
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { FontAwesomeIconProps } from "@fortawesome/react-fontawesome";
import "../../../css/newstyle.css";
class MM extends Component {
	componentDidMount() {
		this.$el = this.el;
		this.mm = new MetisMenu(this.$el);
	}
	componentWillUnmount() {}
	render() {
		return (
			<div className="mm-wrapper">
				<ul className="metismenu" ref={(el) => (this.el = el)}>
					{this.props.children}
				</ul>
			</div>
		);
	}
}

class SideBar extends Component {
	/// Open menu
	componentDidMount() {
		// sidebar open/close
		var btn = document.querySelector(".nav-control");
		var aaa = document.querySelector("#main-wrapper");

		function toggleFunc() {
			return aaa.classList.toggle("menu-toggle");
		}
		btn?.addEventListener("click", toggleFunc);
	}
	state = {
		loveEmoji: false,
	};
	render() {
		/// Path
		let path = window.location.pathname;
		path = path.split("/");
		path = path[path.length - 1];

		const sidebarMenuItems = [
			{
				route: "dashboard",
				title: "Dashboard",
				iconClass: "fa-house-chimney",
			},
			{
				route: "buy-nfm",
				title: "Buy NFM",
				iconClass: "fa-bag-shopping",
			},
			{
				route: "EMI",
				title: "Buy With EMI",
				iconClass: "fa-solid fa-cubes-stacked",
			},
			{
				route: "my-collection",
				title: "My Collection",
				iconClass: "fa-boxes-stacked",
			},
			{
				route: "my-rewards",
				title: "My Rewards",
				iconClass: "fa-coins",
			},
			{
				route: "genesis-node",
				title: "Genesis Node",
				iconClass: "fa-circle-dollar-to-slot",
			},
		];

		return (
			<div className="deznav">
				<PerfectScrollbar className="deznav-scroll">
					<MM className="metismenu" id="menu">
						{sidebarMenuItems.map((menuItem) => (
							<li
								key={menuItem.route}
								className={`${
									path === menuItem.route || path === "" ? "mm-active" : ""
								}`}
							>
								<Link className="has-arrow ai-icon" to={`/${menuItem.route}`}>
									<i class={`fa-solid ${menuItem.iconClass}`}></i>
									<span className="nav-text">{menuItem.title}</span>
								</Link>
							</li>
						))}
					</MM>

					<div className="buttons-ovf">
						<li className="hide-intab">
							<a
								href="https://nitro.network/burn"
								className="enter-button  ecosystem-enter-btn"
								rel="noreferrer"
								target="_blank"
							>
								{" "}
								Burn &nbsp;<i className="fa-solid fa-fire"></i>
							</a>
						</li>
						<li className="hide-intab">
							<a
								href="https://nitro.network/"
								className="enter-button  ecosystem-enter-btn"
								rel="noreferrer"
								target="_blank"
							>
								{" "}
								Enter Ecosystem &nbsp;
								<i className="fa-solid fa-arrow-right-long"></i>
							</a>
						</li>
						<li className="hide-in-desktop">
							<a
								href="https://discord.com/invite/8kQknUCFHs"
								className="enter-button"
								rel="noreferrer"
								target="_blank"
							>
								Join Discord &nbsp;
								<i className="fa-brands fa-discord"></i>
							</a>
						</li>
					</div>

					<div className="copyright">
						{/* <p>
				  <strong>Jobie  Admin Dashboard</strong> <br/>© 2021 All
				  Rights Reserved
				</p>
			 */}
					</div>
				</PerfectScrollbar>
			</div>
		);
	}
}

export default SideBar;
